module.exports = __webpack_public_path__ + "static/media/success_icon.1f60fc67.svg";